import { request, PW_SERVER } from "@/api/client";

/**
 * Fetch the RBAC permission codes granted to the current user.
 * Mirrors the legacy `GET /rbac/v1/permissions` endpoint.
 */
export async function getPermissions(): Promise<string[]> {
  const body = await request<{ permissions?: string[] }>(
    "get",
    `${PW_SERVER}/rbac/v1/permissions`,
    { unwrap: false },
  );
  return body.permissions ?? [];
}
